import React from 'react'
import { PropTypes } from 'prop-types'
import { Container, Button, Alert } from '@sainsburys-tech/fable'
import WithFooter from '../Footer'
import RAMSDeclinePolicy from '../../policyWording/RAMSDeclinePolicy'
import AlreadySignedInModal from '../AlreadySignedInModal'
import redirectUser from '../../utils/routeHelper'
import api from '../../utils/api'
import logger from '../../utils/logger'


class RAMSDecline extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      gpsError: false,
      responseObj: ''
    }
  }

  componentDidMount = () => {
    const { setHeader, setSignOutHeader } = this.props
    setHeader()
    setSignOutHeader(false)
  }


  getFooter = () => (
    <Container size="xl">
      <div className="dsib-firePolicy__footer">
        <div className="dsib-firePolicy__footerInner">
          <Button variant="primary" isFullWidth onClick={this.handleSignOutClick}>Done</Button>
        </div>
      </div>
    </Container>
  )


handleSignOutClick = () => {
  const { history } = this.props
  history.push('/signin')
}


  showGPSError = () => {
    const { gpsError, gpsErrorText } = this.state
    if (gpsError) {
      return (
        <div className="dsib-firePolicy__gpsError">
          <Alert status="error" isOpen message={gpsErrorText} />
        </div>
      )
    }
    return ''
  }

  render() {
    const {
      signInState, history, resetSignIn, signOut
    } = this.props
    return (
      <WithFooter className="dsib-firePolicy" footer={this.getFooter()}>
        <AlreadySignedInModal
          isOpen={signInState.status.alreadySignedIn}
          title="Already Signed In"
          details="You are already signed in"
          okClick={() => {
            resetSignIn()
            redirectUser(history)
          }}
        />
        <Container size="xl">
          <div className="dsib-firePolicy__content">
            {this.showGPSError()}
            <RAMSDeclinePolicy />
          </div>
        </Container>
      </WithFooter>
    )
  }
}

RAMSDecline.propTypes = {
  setHeader: PropTypes.func.isRequired,
  setSignOutHeader: PropTypes.func.isRequired,
  resetSignIn: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  site: PropTypes.shape({
    code: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    distance: PropTypes.number.isRequired
  }),
}

RAMSDecline.defaultProps = {
  site: null
}

export default RAMSDecline
